export default __webpack_public_path__ + "static/media/visa.4ff6a0fc.svg";